import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { HolidaysService, COUNTRY_CODE, LoadHolidaysResponse } from '@cemex-core/cmx-api';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickLoadHolidaysAction,
  OneClickHolidaysActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-holidays.actions';
import { LoadHolidaysCompleteAction } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/actions/load-holidays.actions';
import * as moment from 'moment';

@Injectable()
export class OneClickHolidaysEffects {
  loadHolidaysCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadHolidaysAction(action.payload);
      }),
    ),
  );

  getHolidays = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickHolidaysActionTypes.LOAD_HOLIDAYS),
      map((action: OneClickLoadHolidaysAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.holidaysService
          .getHolidays({
            countryCode: order.customer.countryCode as COUNTRY_CODE,
          })
          .pipe(
            map((response: LoadHolidaysResponse) => {
              let dates: Date[];
              if (response.holidays) {
                dates = [];
                response.holidays.forEach((date) => {
                  if (date.date && date.date.iso) {
                    dates.push(new Date(moment(date.date.iso).toDate()));
                  }
                });
              }
              return new LoadHolidaysCompleteAction(dates);
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private holidaysService: HolidaysService,
  ) {}
}
